import React from "react";
import get from "lodash.get";
import GatsbyConfig from "../../../gatsby-config.js";
import {
  getInLocal,
  setInLocal,
  trackEvent,
  getParamFromQueryString,
} from "../../utils/app-helpers";
import AddNights from "../partials/add-nights";
import Confirmation from "../partials/confirmation";
import HelmetWrapper from "../partials/helmet-wrapper";
import OnLocationHeader from "../partials/onlocation-header";
import SiteFooter from "../partials/site-footer";
import SiteHeader from "../partials/site-header";
import SocialBar from "../partials/social-bar";
import YoureGoing from "../partials/youre-going";
import logo from "../../../static/images/header-lovesong-logo.png";

const { siteMetadata: config } = GatsbyConfig;

export default class PaySuccessPage extends React.Component {
  componentDidMount() {
    const { trip } = this.props;
    const tripData = config.trips[trip];

    setInLocal("lsg.last-viewed-trip", trip);
    trackEvent("Purchase", {
      content_name: `${tripData.name} ${tripData.year}`,
      value: 300,
      currency: "USD",
    });
    this.fetchDataInterval = setTimeout(this.getBookData, 100);
  }

  getBookData = () => {
    let bookData;
    try {
      const data = getInLocal("lsg.book-data", true);
      if (data && data.room) {
        setInLocal("lsg.book-data-confirmed", JSON.stringify(data));
        setInLocal("lsg.book-data", "");
        bookData = data;
      } else {
        bookData = getInLocal("lsg.book-data-confirmed", true);
      }
    } catch (e) {}
    if (bookData && bookData.room) {
      this.setState({ bookData });
    } else {
      setTimeout(this.getBookData, 100);
    }
  };

  render() {
    const bookData = get(this, "state.bookData", {});
    if (typeof window === "undefined" || !bookData.room) return <main />;
    window.scrollTo(0, 0);
    const {
      room,
      firstName,
      lastName,
      firstNameSpouse,
      lastNameSpouse,
    } = bookData;
    const { trip } = this.props;
    const tripData = config.trips[trip];
    const needsHelp = window.location.href.match(/help=true/i);
    const title = `Payment Success – ${tripData.name} ${tripData.year}`;
    const description =
      "Your payment was successful. Thank you for your reservation on the " +
      `Love Song Couples Getaway | ${tripData.name} ${tripData.year}`;
    const roomData = tripData.rooms[room];
    const subscriptionId = getParamFromQueryString("sid", window.location.href);

    if (!bookData || !bookData.room) return <div />;
    const isOnlocation = bookData.promo === "onlocation";
    bookData.primaryName = `${firstName} ${lastName}`;
    bookData.spouseName = `${firstNameSpouse} ${lastNameSpouse}`;

    return (
      <div
        className={`page-pay-success trip-${trip}${
          isOnlocation ? " big-header" : ""
        }`}
      >
        <HelmetWrapper metaTitle={title} metaDescription={description} />
        {isOnlocation ? (
          <OnLocationHeader trip={trip} homeTo={`/${trip}/onlocation`} />
        ) : (
          <SiteHeader trip={trip} />
        )}
        <main>
          {needsHelp ? (
            <p className="error">
              We had trouble sending your confirmation email, <br />
              which contains important information about your trip. <br />
              {config.showPhone ? (
                <strong>Please call us at {config.phone}</strong>
              ) : (
                <a href={`mailto:${config.email}`}>{config.email}</a>
              )}
            </p>
          ) : (
            ""
          )}
          <YoureGoing
            trip={trip}
            name1={firstName}
            name2={firstNameSpouse}
            message="Thank you for your reservation! We look forward to seeing you on"
          />
          <SocialBar trip={trip} />
          <Confirmation trip={trip} bookData={bookData} />
          {subscriptionId && get(roomData, "extraNightPrices.default") ? (
            <AddNights
              trip={trip}
              bookData={bookData}
              subscriptionId={subscriptionId}
            />
          ) : (
            ""
          )}
          <div
            style={{
              backgroundImage: `url(/images/trip-slider-${trip}-venue.jpg)`,
            }}
            className="image mobile-100x40 desktop-300"
          />
        </main>
        <SiteFooter trip={trip} hideNewsletter />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/pay-success.js